exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#featureCardModal .v--modal-box.v--modal{min-height:360px!important;min-width:550px!important}#featureCardModal :not(.v-icon){font-size:12px}#featureCardModal .v-tabs__div:not(:last-child){padding-right:5px}#featureCardModal .v-tabs__div{background-image:linear-gradient(180deg,#2a579a 0,#2a579a),linear-gradient(180deg,#fff 0,#fff);background-clip:content-box,padding-box}#featureCardModal .v-subheader{font-size:14px!important;color:#000!important;font-weight:600!important}#featureCardModal .btn--card{position:absolute;right:10px;bottom:10px}#featureCardModal .caption--identification{display:inline;text-align:center;vertical-align:super}#featureCardModal .v-chip__content{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30db5e81","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/FeatureCard.vue
// module id = 1386
// module chunks = 0